import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({ accountProductLabels: 'productLabels/getProductLabels' }),
    savedProductLabels() {
      return this.$store.getters[
        'conversationProductLabels/getConversationProductLabels'
      ](this.conversationId);
    },
    activeProductLabels() {
      return this.accountProductLabels.filter(({ title }) =>
        this.savedProductLabels.includes(title)
      );
    },
    inactiveProductLabels() {
      return this.accountProductLabels.filter(
        ({ title }) => !this.savedProductLabels.includes(title)
      );
    },
  },
  methods: {
    addProductLabelToConversation(value) {
      const result = this.activeProductLabels.map(item => item.title);
      result.push(value.title);
      this.onUpdateProductLabels(result);
    },
    removeProductLabelFromConversation(value) {
      const result = this.activeProductLabels
        .map(product => product.title)
        .filter(product => product !== value);
      this.onUpdateProductLabels(result);
    },
    async onUpdateProductLabels(selectedProductLabels) {
      this.$store.dispatch('conversationProductLabels/update', {
        conversationId: this.conversationId,
        productLabels: selectedProductLabels,
      });
    },
  },
};

